import * as React from "react";
import PropTypes from "prop-types";
import get from "lodash-es/get";
import { useFormikContext } from "formik";
import { HexColorPicker } from "react-colorful";

import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Typography from "ui/Typography";
import { FormTextField } from "./FormTextField";

export const FormColorPicker = (props) => {
  const { name, buttonProps, popoverProps } = props;
  const formik = useFormikContext();

  const value = get(formik.values, name, "");
  const [colorPickerAnchor, setColorPickerAnchor] = React.useState(null);
  const openColorPicker = (event) => {
    setColorPickerAnchor(event.currentTarget);
  };

  const closeColorPicker = () => {
    setColorPickerAnchor(null);
  };
  const onChange = (value) => {
    formik.setFieldValue(name, value.toUpperCase()).then();
  };

  return (
    <>
      <div
        onClick={openColorPicker}
        className="color-picker-button"
        {...buttonProps}
        style={{ backgroundColor: value }}
      />
      <Popover
        id={open ? "color-picker-popover" : undefined}
        open={Boolean(colorPickerAnchor)}
        anchorEl={colorPickerAnchor}
        onClose={closeColorPicker}
        slotProps={{ paper: { className: "color-picker-paper" } }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        {...popoverProps}
      >
        <HexColorPicker color={value} onChange={onChange} />
        <Stack direction="row" gap="8px" alignItems="center">
          <Typography variant="subtitle1">HEX</Typography>
          <FormTextField
            name={name}
            variant="outlined"
            size="small"
            slotProps={{
              htmlInput: {
                maxLength: "9",
                style: { textAlign: "center" },
              },
            }}
            className="background-color-background"
          />
        </Stack>
      </Popover>
    </>
  );
};

FormColorPicker.propTypes = {
  name: PropTypes.string.isRequired,
  buttonProps: PropTypes.object,
  popoverProps: PropTypes.object,
};
